<div class="p-6">
  <div class="flex justify-end mb-2">
    <div class="text-sm text-gray-600 flex items-center gap-2">
      <span>
        {{ 'meteringpoint.businesstransaction.showtidsserier' | translate }}
      </span>

      <form [formGroup]="form">
        <app-toggle formControlName="showTidsserier"></app-toggle>
      </form>
    </div>
  </div>

  <app-table
    [config]="transactionTableConfig"
    [data]="transactionTableData"
    [(selectedElements)]="selectedElements"
  ></app-table>
</div>
